import * as yaml from 'js-yaml';
const TemplateYamlType = new yaml.Type('!template', { kind: 'mapping' });
export const RESOURCE_SCHEMA = yaml.DEFAULT_SCHEMA.extend(TemplateYamlType);
//# sourceMappingURL=types.js.map